import { withInstall } from '@ll-plus/utils'

import TimelineItem from './src/timeline-item.vue'
import Timeline from './src/timeline.vue'

export const LlTimeline = withInstall(Timeline)
export const LlTimelineItem = withInstall(TimelineItem)

export * from './src/timeline'

declare module 'vue' {
  export interface GlobalComponents {
    LlTimeline: typeof Timeline
    LlTimelineItem: typeof TimelineItem
  }
}
